const importUrl = '/imports';
export default {
    fetchImportDetail(importId) {
        return new Promise((resolve, reject) => {
            ApiClient.get(`${importUrl}/${importId}`, { embed: ['metadata', 'owner'] })
                .then((response) => resolve(response.data))
                .catch((err) => reject(err));
        });
    },
    async fetchImportsList(offset = '') {
        const result = await ApiClient.get(importUrl, {
            embed: ['owner'],
            order: 'created_at',
            direction: 'desc',
            limit: 11,
            offset,
        });
        if (result.status !== 200) {
            throw new Error(result.statusText);
        }
        return result.data;
    },
    fetchImportMetadata: async function () {
        try {
            return (await ApiClient.get(`${importUrl}/metadata`)).data;
        } catch (error) {
            throw new Error(error);
        }
    },
    async fetchImportModel(importData, extension) {
        let acceptHeader = 'text/csv';
        if (extension === 'xlsx') {
            acceptHeader = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        }

        return await ApiClient.call({
            url: `${importUrl}/model`,
            responseType: 'blob',
            data: { ...importData },
            method: 'post',
            headers: {
                accept: acceptHeader,
            },
        });
    },
    async revertImport(batch_id, type) {
        try {
            const response = await ApiClient.post(`${importUrl}/${type}/revert`, {}, { batch_id });
            if (response.status !== 202) {
                throw new Error(response.statusText);
            }

            return response;
        } catch (error) {
            throw new Error(error);
        }
    },
    async cancelImport(batch_id, type) {
        try {
            const response = await ApiClient.post(`${importUrl}/${type}/cancel`, {}, { batch_id });
            if (response.status !== 200) {
                throw new Error(response.statusText);
            }

            return response;
        } catch (error) {
            throw new Error(error);
        }
    },
    async fetchImportCustomFields(filters) {
        const customFielsdResults = [];
        let response = await ApiClient.post('/custom-fields/search?limit=100', {}, { filters });
        customFielsdResults.push(...response.data.data);
        while (customFielsdResults.length < response.data.pagination.total) {
            response = await ApiClient.post(
                `/custom-fields/search?limit=100&offset=${response.data.pagination.offset}`,
                {},
                { filters },
            );
            customFielsdResults.push(...response.data.data);
        }
        return customFielsdResults;
    },
};
